import { render, staticRenderFns } from "./GeoErrorBanner.vue?vue&type=template&id=5fa33e33&scoped=true&lang=pug"
import script from "./GeoErrorBanner.vue?vue&type=script&lang=js"
export * from "./GeoErrorBanner.vue?vue&type=script&lang=js"
import style0 from "./GeoErrorBanner.vue?vue&type=style&index=0&id=5fa33e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa33e33",
  null
  
)

export default component.exports